<template>
  <div
    style="border: 0px solid black; width:100%;display:block;"
  >
    <div
      class="welcome"
      style="border: 0px solid red;display: inline-block;   "
    >
      <row style="border:0px solid green;display: table-cell;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="text-align:center">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-6 col-md-6 col-lg-6">
                <input
                  type="text"
                  v-on:keyup.enter="onSearch"
                  class="form-control"
                  :placeholder="$t('search.input')"
                  v-model="search.text"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
            </div>

            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearch"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-error" style="width=100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b
                >{{ $t("search.result") }} - ({{
                  getLengthSearchDataList()
                }})</b
              >
              <lte-button
                v-if="has_perm('import_apartment') || GET_ACCOUNT_DATA.id == 1"
                style="float:right;background-color:white !important;"
                type="btn btn-default"
                right_icon="fa fa-plus"
                @click="importExcel($event)"
                >{{ $t("apartment.importExcel") }}</lte-button
              >
            </div>
          </div>
          <div class="box-body">
            <table
              class="table table-bordered"
              style="overflow-wrap: break-word; table-layout: fixed; width: 100%; border: 0px solid red;"
            ></table>

            <div v-for="(item, idx) in searchDataList" :key="idx">
              <!-- {{ idx }} -->
              <!-- {{item}} -->
              <search-customer-info v-if="isCustomer(idx)" :item="item" />
              <search-apartment-info
                v-else-if="isResident(idx)"
                :apartment_id="item.apartment.id"
                :item="item"
              />

              <search-invoice-info v-else-if="isInvoice(idx)" :item="item" />

              <!-- @mainperson-save="reload_apartment_details"
                    @customer="handleDataCustomer" -->
            </div>
          </div>
        </div>
        <!-- <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="has_perm('view_apartment') || GET_ACCOUNT_DATA.id == 1"
        >
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div> -->

        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
import LTEButton from "@/components/LTEButton.vue";
import SearchApartmentInfo from "./SearchApartmentInfo";
import SearchCustomerInfo from "./SearchCustomerInfo";
import SearchInvoiceInfo from "./SearchInvoiceInfo";

import LTECoreAlert from "@/components/LTESnackBar.vue";
// import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';

export default {
  name: "Search",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridApartmentDataList: [],
      searchDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "common.code", isHidden: true },
        { text: "apartment.apartment_code", isHidden: true },
        { text: "apartment.size", isHidden: true },
        { text: "apartment.status", isHidden: true },
        { text: "apartment.owner_resident", isHidden: true }
      ],
      columnsApartment: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnApartmentStatus: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        apartment: true
      },
      statusSelected: [],
      actions: ["common.modify", "common.delete"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      // paginatorItem: {
      //   commit_function: "GET_APARTMENT_LIST"
      // },
      search: {
        text: ""
      },
      isLoading: false,
      module_id: 4
    };
  },
  watch: {
    GET_LANG: function() {
    },
    GET_SEARCH_LIST_DATA: function() {
      let data = this.GET_SEARCH_LIST_DATA;
      // console.log(JSON.stringify(data))
      this.searchDataList = data;

      this.getLengthSearchDataList();
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_SEARCH_LIST_DATA",
      "GET_LANG"
    ])
  },
  methods: {
    isResident: function(key) {
      return key.includes("resident");
    },
    isCustomer: function(key) {
      return key.includes("customer");
    },
    isInvoice: function(key) {
      return key.includes("invoice");
    },
    has_perm: function(perm) {
      return null;
    },
    onSelectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) == -1) {
        this.statusSelected.push(parseInt(data.id));
      }
    },
    onUnselectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) != -1) {
        this.statusSelected.splice(
          this.statusSelected.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "apartmentlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearch: function() {
      if (
        !utils.isNull(this.search.text) &&
        this.search.text.length != 0 &&
        this.search.text != ""
      ) {
        this.isLoading = true;
        const data = {
          params: {
            search: this.search.text
          }
        };

        this.GET_SEARCH_LIST(data).then(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
        this.getLengthSearchDataList();
      } else {
        this.ON_SHOW_TOAST({
          message: "common.please_enter_fields",
          styleType: "danger"
        });
      }
    },
    getLengthSearchDataList: function() {
      if (this.searchDataList.page == undefined)
        delete this.searchDataList.page;
      return Object.keys(this.searchDataList).length;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_SEARCH_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      // "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG"
    ])
  },
  components: {
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    // paginator: Paginator,
    loading: Loading,
    "search-apartment-info": SearchApartmentInfo,
    "search-customer-info": SearchCustomerInfo,
    "search-invoice-info": SearchInvoiceInfo
  },
  async mounted() {
  }
};
</script>

<style scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.size-180 {
  width: 180px;
}

.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.select-option-status {
  margin-top: -12px;
  display: inline-block;
}

@media only screen and (max-width: 1000px) {
  .select-option-status {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-status {
    float: none;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/Search.vue